import { useSiteConfig } from 'mf_core/config';
import { useFeatureFlag } from 'mf_core/feature-flag';
import { useLocation } from 'react-router';

export const useShowBillingModeSelector = (
  showQuoteIcon: boolean | undefined
) => {
  const { siteCode } = useSiteConfig();
  const location = useLocation();

  const { isReady, value: boData } = useFeatureFlag([
    'im-marketing-billing-mode-selector-enabled',
  ]);

  const showBillingModeSelector =
    siteCode === 'br' &&
    isReady &&
    boData['im-marketing-billing-mode-selector-enabled'] === 'true' &&
    location &&
    !showQuoteIcon &&
    !location.pathname.includes('orderConfirmation') &&
    !location.pathname.includes('checkout') &&
    !location.pathname.includes('vendorRequestedInformation') &&
    !location.pathname.includes('quoteitems') &&
    !location.pathname.includes('quotedetails');

  return showBillingModeSelector;
};
